import { FirebaseApp } from "firebase/app";
import { initializeAppCheck, ReCaptchaV3Provider } from "firebase/app-check";
import { config } from "JS/Config";
import { captureSentryError } from "JS/Helpers/SentryHelper";

const initializedApps = new Set<string>();

export function initializeFirebaseAppCheck(app: FirebaseApp) {
    const appName = app.name;
    if (config.recaptchaSiteKey && !initializedApps.has(appName)) {
        try {
            initializeAppCheck(app, {
                provider: new ReCaptchaV3Provider(config.recaptchaSiteKey),
                isTokenAutoRefreshEnabled: true,
            });
            initializedApps.add(appName);
        } catch (err) {
            captureSentryError(err as Error, {
                location: "AppCheck-init",
                appName,
            });
        }
    }
}
